// extracted by mini-css-extract-plugin
export default {"wrapper":"YoMdb","title":"aIOgY","blocks":"jwCAZ"};